export default __webpack_public_path__ + "static/media/Canal_Saude.3ec971e9.png";